export const RequiredAsterisk = () => (
    <span className="text-danger-500 ml-0.5" title="Required">*</span>
  );